import React from "react";
import '../../css/Count.css';

export default function Count() {
  return (
    <section className="count-section">
      <div className="count-grid">

        <div className="count-item">
          <h4 className="count-number">17000+</h4>
          <p className="count-text">AI-Generated test cases</p>
        </div>

        <div className="count-item">
          <h4 className="count-number">480+</h4>
          <p className="count-text">New defects created per day</p>
        </div>

        <div className="count-item">
          <h4 className="count-number">33000+</h4>
          <p className="count-text">Test cases executed monthly</p>
        </div>

      </div>
    </section>
  );
}